import React from 'react';

type EditIconProps = {
  className?: string;
  onClick?: () => void;
  size?: number;
  color?: string | undefined;
  strokeWidth?: number
};

const VerifyIcon = ({ color = '#003366', size = 20, strokeWidth = 1.2, className, onClick }: EditIconProps) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.375 11.4583L5.11109 15.1943C5.32588 15.4092 5.67412 15.4092 5.88891 15.1943L8.25 12.8333" stroke={color} strokeWidth="1.375" strokeLinecap="round" />
    <path d="M14.6667 6.41675L11 10.0834" stroke={color} strokeWidth="1.375" strokeLinecap="round" />
    <path d="M6.41797 11.0001L10.6124 15.1945C10.8272 15.4093 11.1754 15.4093 11.3902 15.1945L20.168 6.41675" stroke={color} strokeWidth="1.375" strokeLinecap="round" />
  </svg>


);

export default VerifyIcon;